export default __webpack_public_path__ + "static/media/koala.17d147db.png";